import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    lang,
    setLang,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);
  const navLinks = [{
    label: t.nav.inicio,
    href: '#inicio'
  }, {
    label: t.nav.servicios,
    href: '#servicios'
  }, {
    label: t.nav.portfolio,
    href: '#portafolio'
  }, {
    label: t.nav.sobre,
    href: '#sobre'
  }, {
    label: t.nav.faq,
    href: '#faq'
  }, {
    label: t.nav.contact,
    href: '#contacto'
  }];
  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.5
    }} className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-inkova-cream/95 backdrop-blur-md shadow-sm border-b border-inkova-primary/10 py-4' : 'bg-inkova-cream/95 backdrop-blur-md border-b border-inkova-primary/10 py-4'}`} data-id="element-251">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-252">
          <a href="#inicio" className="flex items-center gap-3" data-id="element-253">
            <div className="bg-inkova-primary rounded-[10px] px-3 py-2 flex items-center" data-id="element-254">
              <img src="https://cdn.magicpatterns.com/uploads/owVcxkWT6ABhGYw2qQLWVA/INK_PNG.png" alt="Inkova Creation" className="h-7 w-auto block" data-id="element-255" />
            </div>
            <div className="flex-col hidden sm:flex" data-id="element-256">
              <span className="text-[10px] text-inkova-primary tracking-wide uppercase font-semibold" data-id="element-257">
                Business Consulting & Creation
              </span>
            </div>
          </a>

          {/* Desktop nav links */}
          <div className="hidden lg:flex items-center gap-8" data-id="element-258">
            <div className="flex gap-8" data-id="element-259">
              {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-medium text-inkova-dark hover:text-inkova-primary transition-colors duration-200" data-id="element-260">
                  {link.label}
                </a>)}
            </div>

            <div className="flex items-center ml-4 bg-inkova-primary/5 rounded-full p-1 border border-inkova-primary/10" data-id="element-261">
              <button onClick={() => setLang('es')} className={`px-3 py-1 rounded-full text-xs font-bold transition-all ${lang === 'es' ? 'bg-white text-inkova-primary shadow-sm' : 'text-inkova-dark/60 hover:text-inkova-dark'}`} aria-pressed={lang === 'es'} aria-label="Español" data-id="element-262">
                ES
              </button>
              <button onClick={() => setLang('en')} className={`px-3 py-1 rounded-full text-xs font-bold transition-all ${lang === 'en' ? 'bg-white text-inkova-primary shadow-sm' : 'text-inkova-dark/60 hover:text-inkova-dark'}`} aria-pressed={lang === 'en'} aria-label="English" data-id="element-263">
                EN
              </button>
            </div>

            <a href="https://wa.me/13054781618" target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 rounded-full font-semibold text-sm bg-inkova-primary text-white hover:bg-inkova-dark-purple transition-all duration-300" data-id="element-264">
              {t.nav.cta}
            </a>
          </div>

          {/* Mobile: CTA + hamburger */}
          <div className="flex lg:hidden items-center gap-3" data-id="element-265">
            <div className="flex items-center bg-inkova-primary/5 rounded-full p-1 mr-1 border border-inkova-primary/10" data-id="element-266">
              <button onClick={() => setLang('es')} className={`px-2 py-1 rounded-full text-[10px] font-bold transition-all ${lang === 'es' ? 'bg-white text-inkova-primary shadow-sm' : 'text-inkova-dark/60 hover:text-inkova-dark'}`} aria-pressed={lang === 'es'} aria-label="Español" data-id="element-267">
                ES
              </button>
              <button onClick={() => setLang('en')} className={`px-2 py-1 rounded-full text-[10px] font-bold transition-all ${lang === 'en' ? 'bg-white text-inkova-primary shadow-sm' : 'text-inkova-dark/60 hover:text-inkova-dark'}`} aria-pressed={lang === 'en'} aria-label="English" data-id="element-268">
                EN
              </button>
            </div>

            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-inkova-dark p-2 focus:outline-none" aria-label={isMenuOpen ? 'Cerrar menú' : 'Abrir menú'} data-id="element-269">
              {isMenuOpen ? <X className="w-6 h-6" data-id="element-270" /> : <Menu className="w-6 h-6" data-id="element-271" />}
            </button>
          </div>
        </div>
      </motion.nav>

      {/* Mobile menu overlay */}
      <AnimatePresence data-id="element-272">
        {isMenuOpen && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-40 bg-black/20 lg:hidden backdrop-blur-sm" onClick={() => setIsMenuOpen(false)} data-id="element-273" />}
      </AnimatePresence>

      {/* Mobile menu panel */}
      <AnimatePresence data-id="element-274">
        {isMenuOpen && <motion.div initial={{
        y: -20,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: -20,
        opacity: 0
      }} transition={{
        type: 'tween',
        duration: 0.2
      }} className="fixed top-[72px] left-0 right-0 bg-white z-50 shadow-xl lg:hidden flex flex-col rounded-b-2xl border-t border-inkova-primary/10" data-id="element-275">
            <nav className="flex flex-col p-6 gap-5" data-id="element-276">
              {navLinks.map((link, i) => <motion.a key={link.href} href={link.href} onClick={handleLinkClick} initial={{
            opacity: 0,
            x: -10
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: i * 0.05
          }} className="text-base font-medium text-inkova-dark hover:text-inkova-primary transition-colors" data-id="element-277">
                  {link.label}
                </motion.a>)}

              <motion.a href="https://wa.me/13054781618" target="_blank" rel="noopener noreferrer" onClick={handleLinkClick} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: navLinks.length * 0.05
          }} className="mt-2 w-full text-center px-6 py-3 rounded-full bg-inkova-primary text-white font-semibold hover:bg-inkova-dark-purple transition-colors duration-300" data-id="element-278">
                {t.nav.cta}
              </motion.a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </>;
}